import { render } from "./HeaderMenu.vue?vue&type=template&id=21d902fa&scoped=true"
import script from "./HeaderMenu.vue?vue&type=script&lang=js"
export * from "./HeaderMenu.vue?vue&type=script&lang=js"

import "./HeaderMenu.vue?vue&type=style&index=0&id=21d902fa&scoped=true&lang=css"

import exportComponent from "/home/denis/Projects/tavria/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21d902fa"]])

export default __exports__